import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var ATTRIBUTE = "data-ccp-web-components";
var createStyleElement = function createStyleElement() {
  var el = document.createElement("style");
  el.type = "text/css";
  return el;
};
var appendToHead = function appendToHead(style) {
  var insertAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bottom";
  var preserveOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var head = document.head || document.getElementsByTagName("head")[0];
  if (insertAt === "top") {
    if (head.firstChild) {
      if (preserveOrder) {
        var firstNonImplant = Array.from(head.children).find(function (child) {
          return child.getAttribute(ATTRIBUTE) === null;
        });
        if (firstNonImplant) {
          head.insertBefore(style, firstNonImplant);
        } else {
          head.appendChild(style);
        }
      } else {
        head.insertBefore(style, head.firstChild);
      }
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
};
var styleImport = function styleImport(css, options) {
  if (!css || typeof document === "undefined") return false;
  var _ref = options || {},
    attributes = _ref.attributes,
    insertAt = _ref.insertAt,
    preserveOrder = _ref.preserveOrder;
  var style = createStyleElement();
  appendToHead(style, insertAt, preserveOrder);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  style.setAttribute(ATTRIBUTE, "");
  if (attributes) {
    Object.entries(attributes).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];
      return style.setAttribute(k, v);
    });
  }
  return true;
};
export { styleImport };